module.exports = "/_next/static/images/uv-404-8a3ba05f6201782095d754ade2e0fbb1.png";